import script from "./page_not_found.vue?vue&type=script&setup=true&lang=ts"
export * from "./page_not_found.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__